import { useAlert } from "../../providers/AlertProvider";

import { IToastAlert } from "../../commons/interfaces";
import { CloseIcon, ErrorIcon, SuccessIcon, WarningIcon } from "./Icons";

import "../../styles/toastAlert.css";

interface IProps {
    item: IToastAlert;
}

const ToastAlert = ({ item }: IProps) => {
    const { type, message, id } = item;

    const ToastIcon: any = {
        success: <SuccessIcon />,
        warning: <WarningIcon />,
        error: <ErrorIcon />,
    };

    const icon = ToastIcon[type];

    const alert = useAlert();

    return (
        <div className={`cr-toast cr-toast-${type}`}>
            <div className="cr-toast-message">
                {icon && <div className="cr-icon cr-icon-thumb">{icon}</div>}
                <p>{message}</p>
            </div>
            <div className="cr-close-icon" onClick={() => alert.closeAlert(id)}>
                <CloseIcon />
            </div>
        </div>
    );
};

export default ToastAlert;
